"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
const tslib_1 = require("tslib");
const EnumObject_1 = require("./EnumObject");
const ValueObject_1 = require("./ValueObject");
const Guard_1 = require("../logic/Guard");
const ERoleLabel_1 = require("./ERoleLabel");
const Role_validator_1 = tslib_1.__importDefault(require("./Role.validator"));
const genericRoleDefs_1 = require("../../common/domain/definitions/genericRoleDefs");
class Role extends ValueObject_1.ValueObject {
    constructor(p) {
        super(p);
    }
    hasLabelSupport() {
        return EnumObject_1.EnumObject.includes(this._props.labels, ERoleLabel_1.ERoleLabel.V.SUPPORT);
    }
    hasLabelClient() {
        return EnumObject_1.EnumObject.includes(this._props.labels, ERoleLabel_1.ERoleLabel.V.CLIENT);
    }
    static validate(raw, ref) {
        try {
            Role_validator_1.default(raw);
            return Guard_1.Guard.pass();
        }
        catch (e) {
            ValueObject_1.ValueObject.handleValidationError(e, ref);
            return Guard_1.Guard.fail(e.message);
        }
    }
    static create(p) {
        return new Role(p);
    }
    static addRoleDTOByCode(roles, roleCode, customRolesDefsByCode) {
        if (genericRoleDefs_1.genericRoleDefsByCode[roleCode]) {
            roles[roleCode] = genericRoleDefs_1.genericRoleDefsByCode[roleCode];
        }
        else if (customRolesDefsByCode[roleCode]) {
            roles[roleCode] = customRolesDefsByCode[roleCode];
        }
        else {
            console.error(`Role def not found for ${roleCode} - skipping`);
            return;
        }
    }
}
exports.Role = Role;
//# sourceMappingURL=Role.js.map